export const getLangName = (lang: string) => {
  switch (lang) {
    case 'de':
      return 'Deutsch';
    case 'uk':
      return 'Ukrainian';
    default:
      return 'English';
  }
};
